const initialState = {
  loading: false,
  data: [],
  totals: { total_qty: 0, total_weight_gms: 0, total_weight_cts: 0 },
  error: null,
};

const stoneStockAddedReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'STONE_STOCK_ADDED_REPORT_REQUEST':
      return { ...state, loading: true, error: null };
    case 'STONE_STOCK_ADDED_REPORT_SUCCESS':
      return { ...state, loading: false, data: action.payload.rows, totals: action.payload.totals };
    case 'STONE_STOCK_ADDED_REPORT_FAILURE':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default stoneStockAddedReportReducer; 